export const PUBLIC_SIGNING_ROUTE = "/sign/:token";

export const isPublicSigningRoute = (pathname = "") => /^\/sign\/[^/]+\/?$/.test(pathname);

export const isValidSigningToken = (token = "") => /^[A-Za-z0-9_-]{10,256}$/.test(token);
